import axios from 'axios';

export const parishApi = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND!}api/parish`,
    headers: {
        'Content-Type': 'application/json'
    }
})